module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('input', {
    ref: "searchbox",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('dictionary.search.placeholder')
    },
    on: {
      "input": _vm.search
    }
  }), _vm._v(" "), _c('inline-svg', {
    staticClass: "search-icon",
    class: _vm.ltr ? 'dir-right' : 'dir-left',
    attrs: {
      "width": "40px",
      "src": require('../../assets/svg/searchbaricon.svg').default
    }
  })], 1), _vm._v(" "), (_vm.matchWords.length) ? _c('div', {
    staticClass: "options"
  }, [_vm._l((_vm.matchWords), function(word) {
    return _c('div', {
      key: word.idd,
      staticClass: "opt flex",
      on: {
        "click": function($event) {
          return _vm.selectWord(word)
        }
      }
    }, [(word.heb) ? _c('div', {
      staticClass: "heb hebFlex"
    }, [_c('div', {
      staticClass: "translated-word"
    }, [_c('span', [_vm._v(_vm._s(word.Eng))])]), _vm._v(" "), _c('div', {
      staticClass: "original-word"
    }, [_c('span', [_vm._v(_vm._s(word.heb))])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "opt flex addWordCls",
    on: {
      "click": _vm.addWord
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("dictionary.search.title")) + "\n      ")])], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7cf1f96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dictionary/search.vue
// module id = 367
// module chunks = 0 5